import React from 'react';
import SettingsManagement from './SettingsManagement';

const Settings = () => {
  return <SettingsManagement />;
};

export default Settings; 